import { Link } from 'react-router-dom';
import { ProjectFooterStyles } from '../../styles/styles';

type Prop = {
  next: string;
};

const ProjectFooter = (props: Prop) => {
  const { next } = props;
  return (
    <ProjectFooterStyles data-scroll-section>
      <Link to={`/projects/${next}`} className="next">
        next <span>&rsaquo;</span>
      </Link>
    </ProjectFooterStyles>
  );
};

export default ProjectFooter;
